import jwt_decode from "jwt-decode";
import authApi from "../auth";
import { storeData } from "../../store";

export const customFetch = async (uri, options) => {
    let session = JSON.parse(sessionStorage.getItem("vue-session-key"));
    const refreshToken = session.refreshToken;
    const accessToken = session.accessToken;

    // If refresh token expired
    if (isTokenExpired(refreshToken)) {
        logout();
        return;
    }

    // If access token expired
    if (isTokenExpired(accessToken)) {
        const accessToken = await generateAccessToken(refreshToken);
        if (!accessToken) {
            logout();
            return;
        }
        session.accessToken = accessToken;
        sessionStorage.setItem("vue-session-key", JSON.stringify(session));
        options.headers.Authorization = `Bearer ${accessToken}`;
    }

    // Initiate request
    const initialRequest = fetch(uri, options);
    return initialRequest
        .then(response => {
            return response.json();
        })
        .then(async json => {
            if (
                json.errors &&
                json.errors[0] &&
                json.errors[0].extensions.code === "invalid-jwt" &&
                json.errors[0].message.includes("JWTExpired")
            ) {
                // Checking refresh token expired
                if (isTokenExpired(refreshToken)) {
                    logout();
                    return;
                }

                const accessToken = await generateAccessToken(refreshToken);
                if (!accessToken) {
                    logout();
                    return;
                }
                session.accessToken = accessToken;
                sessionStorage.setItem(
                    "vue-session-key",
                    JSON.stringify(session)
                );
                options.headers.Authorization = `Bearer ${accessToken}`;
            }

            // If there were no errors in the request, we need to repackage the promise and return it as the final result.
            return {
                ok: true,
                text: () =>
                    new Promise(function(resolve, reject) {
                        resolve(JSON.stringify(json));
                    })
            };
        });
};

async function generateAccessToken(refreshToken) {
    try {
        const res = await authApi.generateAuth({
            email: storeData.currentUserDetails.email,
            refreshToken
        });
        const result = res?.data;
        if (result.statusCode === 200) {
            storeData.currentUserDetails = result.data.details;
            console.log("New access token generated");
            return result.data.accessToken;
        } else {
            return null;
        }
    } catch (err) {
        return null;
    }
}

function isTokenExpired(token) {
    try {
        let decoded = jwt_decode(token);
        return decoded.exp < parseInt(+new Date() / 1000);
    } catch (err) {
        return true;
    }
}

function logout() {
    // window.location.href = "/login";
    console.log("logout");
    sessionStorage.clear();
    localStorage.removeItem("store");
}
